import axios from 'axios';
import authService from '../services/authService';

// QuickBooks OAuth Configuration
export const QUICKBOOKS_CONFIG = {
  // OAuth URLs
  AUTHORIZATION_URL: 'https://appcenter.intuit.com/connect/oauth2',
  TOKEN_URL: 'https://oauth.platform.intuit.com/oauth2/v1/tokens/bearer',
  
  // API URLs
  BASE_API_URL: 'https://quickbooks.api.intuit.com', // Production API
  
  // OAuth Settings
  SCOPE: 'com.intuit.quickbooks.accounting',
  RESPONSE_TYPE: 'code',
  
  // Use ngrok domain specifically for QuickBooks OAuth callback only
  // This minimizes ngrok usage to just the OAuth flow
  REDIRECT_URI: 'https://grown-many-marlin.ngrok-free.app/quickbooks/callback'
};

// Get global QB credentials from admin settings
export const getQuickBooksCredentials = async () => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required to fetch QuickBooks credentials');
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL || 'http://localhost:9003'}/api/admin/settings`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data.success && response.data.settings) {
      const settings = response.data.settings;
      const clientId = settings.qb_global_client_id?.value || '';
      const clientSecret = settings.qb_global_client_secret?.value || '';
      
      if (!clientId || !clientSecret) {
        console.warn('QuickBooks credentials not configured in admin settings');
        return {
          clientId: '',
          clientSecret: ''
        };
      }
      
      return {
        clientId,
        clientSecret
      };
    }
    
    throw new Error('Failed to fetch settings from API');
  } catch (error) {
    console.error('Error fetching QuickBooks credentials:', error);
    // Return empty credentials instead of throwing to prevent crashes
    return {
      clientId: '',
      clientSecret: ''
    };
  }
};

// QuickBooks API helper functions
export const generateAuthUrl = async (state) => {
  try {
    const credentials = await getQuickBooksCredentials();
    const params = new URLSearchParams({
      client_id: credentials.clientId,
      scope: QUICKBOOKS_CONFIG.SCOPE,
      redirect_uri: QUICKBOOKS_CONFIG.REDIRECT_URI,
      response_type: QUICKBOOKS_CONFIG.RESPONSE_TYPE,
      state: state
    });
    
    return `${QUICKBOOKS_CONFIG.AUTHORIZATION_URL}?${params.toString()}`;
  } catch (error) {
    throw new Error(`Failed to generate auth URL: ${error.message}`);
  }
};

export const formatCustomerData = (qbCustomer) => {
  return {
    name: qbCustomer.FullyQualifiedName || `${qbCustomer.GivenName || ''} ${qbCustomer.FamilyName || ''}`.trim(),
    email: qbCustomer.PrimaryEmailAddr?.Address || '',
    phone: qbCustomer.PrimaryPhone?.FreeFormNumber || '',
    address: qbCustomer.BillAddr ? 
      `${qbCustomer.BillAddr.Line1 || ''} ${qbCustomer.BillAddr.City || ''} ${qbCustomer.BillAddr.PostalCode || ''}`.trim() : '',
    companyName: qbCustomer.CompanyName || '',
    qbCustomerId: qbCustomer.Id,
    qbSyncToken: qbCustomer.SyncToken,
    qbCreatedDate: qbCustomer.MetaData?.CreateTime ? new Date(qbCustomer.MetaData.CreateTime) : null,
    qbLastUpdatedDate: qbCustomer.MetaData?.LastUpdatedTime ? new Date(qbCustomer.MetaData.LastUpdatedTime) : null,
    importedAt: new Date(),
    source: 'quickbooks'
  };
};